/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiV3ServiceRemoveVehicleDelete$Params {

/**
 * Interface language
 */
  lang?: string;

/**
 * id ts
 */
  vehId?: number;
}

export function apiV3ServiceRemoveVehicleDelete(http: HttpClient, rootUrl: string, params?: ApiV3ServiceRemoveVehicleDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceRemoveVehicleDelete.PATH, 'delete');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('vehId', params.vehId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV3ServiceRemoveVehicleDelete.PATH = '/api/v3/service/RemoveVehicle';
